export enum EButtonTypeV2 {
  REDEMPTION = 'redemption-in-progress',
  INVESTMENT = 'investment-in-progress',
  APPROVALS = 'approvals',
  REGISTER = 'register',
  IN_PORTABILITY = 'incoming-portability',
  OUT_PORTABILITY = 'outgoing-portability',
  REQUESTS_PORTABILITY = 'requests-portability'
}

export interface IHomeButtonsV2 {
  title: string;
  buttons: IButtonDataV2[];
}

export interface IButtonDataV2 {
  icon: string;
  total: string;
  label: string;
  type: EButtonTypeV2;
}

export enum EButtonTypeV3 {
  REDEMPTION = 'redemption-in-progress',
  INVESTMENT = 'investment-in-progress',
  APPROVALS = 'approvals',
  REGISTER = 'register',
  PORTABILITY_IN_PROGRESS = 'portability-in-progress',
  PORTABILITY_REQUESTS = 'portability-requests'
}

export interface IHomeButtonsV3 {
  title: string;
  buttons: IButtonDataV3[];
}

export interface IButtonDataV3 {
  icon: string;
  total: string;
  label: string;
  type: EButtonTypeV3;
}
